'use client'

import React, { HTMLAttributes } from 'react'

import { cn } from '@podo-app/design-system-temp'

interface SectionProps extends HTMLAttributes<HTMLDivElement> {
  title?: string
  spacing?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
}

const Section = ({ title, spacing = 'md', className, children, ...props }: SectionProps) => {
  const spacingClasses = {
    sm: 'py-2.5',
    md: 'py-[15px]',
    lg: 'py-5',
  }

  return (
    <section className={cn('w-full', spacingClasses[spacing], className)} {...props}>
      {title && <h2 className="text-xl font-semibold mb-2.5 text-gray-900">{title}</h2>}
      {children}
    </section>
  )
}

export default Section
